import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useUserProfile } from "@/features/auth/model/use-user-profile";
import { notificationMessageQueryKeys } from "@/features/notification/api/notification-message";
import { useDateFormat } from "@/shared/hooks/use-date-format";
import { useLanguage } from "@/shared/hooks/use-language";
import {
  dateFormatByWireDateFormat,
  isSavedSetting,
  languageByWireLanguage,
} from "@/shared/lib/user-setting";

export const UserSettingSync = () => {
  const queryClient = useQueryClient();
  const { setting } = useUserProfile();
  const { language, setLanguage } = useLanguage();
  const { setDateFormat } = useDateFormat();
  const appliedSignature = useRef<string | null>(null);
  const observedLanguage = useRef(language);

  useEffect(() => {
    if (!setting || !isSavedSetting(setting)) return;
    const signature = `${setting.language}|${setting.date_format}`;
    if (appliedSignature.current === signature) return;
    appliedSignature.current = signature;
    if (setting.language) setLanguage(languageByWireLanguage[setting.language]);
    if (setting.date_format) setDateFormat(dateFormatByWireDateFormat[setting.date_format]);
  }, [setting, setLanguage, setDateFormat]);

  useEffect(() => {
    if (observedLanguage.current === language) return;
    observedLanguage.current = language;
    queryClient.invalidateQueries({ queryKey: notificationMessageQueryKeys.all });
  }, [language, queryClient]);

  return null;
};
